export class AddParticipantDto {
  account_id?: string;
  name?: string;
  email?: string;
  phoneNumber?: string;
}
